var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHeader)?_c('div',{staticClass:"sf-branch-section"},[(_vm.config.title)?_c('div',{staticClass:"bs-title"},[_vm._v(_vm._s(_vm.config.title))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }